/**
 * Product Form - Cart Drawer Integration
 * Prevents redirect to cart page and opens drawer instead
 */

(function() {
  'use strict';

  function openCartDrawer() {
    const cartDrawer = document.querySelector('cart-drawer-component');
    if (cartDrawer && typeof cartDrawer.open === 'function') {
      cartDrawer.open();
    }
  }

  function handleProductFormSubmit(event) {
    const form = event.target;
    
    // Only handle product_form from single product page
    if (!form || form.id !== 'product_form') return;
    
    event.preventDefault();
    event.stopPropagation();

    const formData = new FormData(form);
    const submitButtons = form.querySelectorAll('[type="submit"]');
    
    // Disable all submit buttons
    submitButtons.forEach(btn => {
      btn.disabled = true;
      const span = btn.querySelector('span');
      if (span) span.textContent = 'Adding...';
    });

    // Submit via AJAX
    fetch('/cart/add.js', {
      method: 'POST',
      body: formData
    })
      .then(response => response.json())
      .then(data => {
        // Re-enable buttons
        submitButtons.forEach(btn => {
          btn.disabled = false;
          const span = btn.querySelector('span');
          if (span) span.textContent = 'Add to Cart';
        });

        // Dispatch cart add event
        document.dispatchEvent(new CustomEvent('theme:cart:add', {
          detail: { data },
          bubbles: true
        }));

        // Open cart drawer
        setTimeout(() => {
          openCartDrawer();
        }, 100);
      })
      .catch(error => {
        // Re-enable buttons on error
        submitButtons.forEach(btn => {
          btn.disabled = false;
          const span = btn.querySelector('span');
          if (span) span.textContent = 'Add to Cart';
        });
      });
  }

  function init() {
    // Listen for form submissions
    document.addEventListener('submit', handleProductFormSubmit);
  }

  // Initialize when DOM is ready
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
